<template>
  <div class="chronology-main">
    <title-screen title ="4"></title-screen>
    <p class="title-message"><i class="el-icon-caret-right"></i>
      入力しても保存はされません。保存したい方は会員登録/ログインしてから入力をお願いします。
    </p>
    <div v-if="tableData.length > 0">
      <div class="mt2 text-center">
        <p class="color-red">表は左右にスクロールすることができます</p>
        <el-button class="float-right" @click="editChronologyPage()">家族年表を変更する</el-button>
      </div>
      <div class="mt2">
        <div  class="table-responsive table-shadow table-chronology">
          <div class="table-wrap">
            <table class="table m-0">
              <thead>
              <th style="min-width: 150px" class="first-column">年</th>
              <template v-for="(data, index) in tableHeader">
                <th :key="index" :value="index" :width="data.width">
                  {{data.header}}
                </th>
              </template>
              </thead>
              <tbody>
              <template v-for="(data, index) in tableData">
                <tr :key="index" :value="index">
                  <td width="150 " class="first-column">
                    <div v-if="data.type==='member'">{{data.name}}</div>
                    <div v-if="data.type==='event'" class="d-flex justify-content-center">
                      <div class="vertical-rl">{{data.name}}</div>
                    </div>
                  </td>
                  <template v-for="(value, key) in data">
                    <td :key="key" :value="key" v-if="(key !=='name' && key !== 'type')" :class="getClassCell(data, value)" class="vertical-align-top">
                      <div v-if="data.type==='member'">
                        {{value.yearOld}}
                      </div>
                      <div v-if="data.type==='event'" class="">
                        <table class="vertical-align-top table--border-0 table--background-0 child-table" style="width: 100%">
                          <tr>
                            <th v-for="(event, eIndex) in value" :key="`member_${index}_${eIndex}`" >
                              <div class="vertical-rl text-orientation-upright d-flex m-auto life-event__member-name">{{event.memberName}}</div>
                            </th>
                          </tr>
                          <tr>
                            <td v-for="(event, eIndex) in value" :key="`event_${index}_${eIndex}`" class="child-table-td">
                              <div class="vertical-rl text-orientation-upright d-flex m-auto cursor-pointer life-event__event-name" @click="handleClickEvent(event)">
                                <span v-if="event.eventUrl" style="color: #0c59cf; cursor:pointer;">{{event.eventName}}</span>
                                <span v-else>{{event.eventName}}</span>
                              </div>
                            </td>
                          </tr>
                        </table>
                      </div>
                    </td>
                  </template>
                </tr>
              </template>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div v-if="tableData.length === 0">
      <div class="mt2 text-center">
        <p class="color-red">データなし</p>
      </div>
    </div>
    <div class="mt2 text-right text-center-mobile" v-if="tableData.length <= 0">
      <el-button @click="editChronologyPage()">家族年表を変更する</el-button>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'
  import TitleScreen from '@/components/common/TitleScreen'
  import { INHERITANCE_OCCURS_EVENT_MASTER_KEYS } from '../../../common/constance'

  export default {
    name: 'Chronology',
    components: {
        'title-screen': TitleScreen
    },
    data () {
      return {
        // memberFamilies: [],
        tableHeader: [],
        tableData: []
      }
    },
    methods: {
      getClassCell (data, value) {
        if (data.type === 'event') {
          return 'cell-padding-0'
        }
        if (value.hasEvent) {
          return 'cell--highlight'
        } else {
          return ''
        }
      },
      loadEventTable () {
        if (this.memberFamilies && this.memberFamilies.length === 0) {
          this.tableHeader = ''
          this.tableData = ''
          return
        }

        // Group event in year
        const listEventYear = {}
        for (const member of this.memberFamilies) {
          for (const chronology of member.myChronicleResponseDTOS) {
            const year = +moment(member.birthday).format('YYYY') + chronology.eventYear
            const event = {
              memberName: member.name,
              eventName: chronology.eventName,
              eventUrl: chronology.eventUrl
            }
            if (listEventYear[year]) {
              listEventYear[year].push(event)
            } else {
              listEventYear[year] = [event]
            }
          }
        }
        // 未来のイベントしかない場合は、今年から開始するようにする。
        const thisYear = new Date().getFullYear()
        // years without events
        const listEventYearKey = Object.keys(listEventYear)
        let minYear = Math.min(...listEventYearKey)
        if (minYear > thisYear) {
            minYear = thisYear
        }
        const maxYear = Math.max(...listEventYearKey)
        for (let year = minYear; year <= maxYear; year++) {
          if (!listEventYear[year]) {
            listEventYear[year] = ''
          }
        }

        // Make table header
        const keysSorted = Object.keys(listEventYear).sort((a, b) => +a - +b)
        const tableHeader = keysSorted.map(key => {
          const length = listEventYear[key].length
          const width = listEventYear[key].length >= 2 ? length * 25 + (length - 1) * 10 + 40 : 'auto'
          return {
            'header': key,
            'width': width
          }
        })

        // Make table data
        const tableData = []
        for (const member of this.memberFamilies) {
          const memberRow = {
            name: member.name,
            type: 'member'
          }
          const inheritanceOccursEvent = member.myChronicleResponseDTOS.find(e => INHERITANCE_OCCURS_EVENT_MASTER_KEYS.includes(e.eventMasterKey))
          for (const key of keysSorted) {
            const eventYear = key - +moment(member.birthday).format('YYYY')
            const event = member.myChronicleResponseDTOS.find(e => +e.eventYear === +eventYear)
            memberRow[key] = {
              yearOld: eventYear >= 0 && eventYear <= 100 && (!inheritanceOccursEvent || eventYear <= inheritanceOccursEvent.eventYear) ? eventYear : '',
              hasEvent: !!event
            }
          }
          tableData.push(memberRow)
        }

        const allEventYear = Object.assign({ 'name': 'ライフイベント', 'type': 'event' }, listEventYear)
        this.tableHeader = tableHeader
        this.tableData = [...tableData, allEventYear]
      },
      editChronologyPage () {
        this.$emit('backToEdit')
      },
      cellClassName (option) {
        const { row, columnIndex } = option
        if (columnIndex === 0 && row.type === 'member') {
          return
        }

        if (row.type === 'member') {
          const year = this.tableHeader[columnIndex - 1].header
          const eventYear = row[year]

          return eventYear && eventYear.hasEvent ? 'cell--highlight' : ''
        }

        if (row.type === 'event') {
          return 'vertical-align-top'
        }
      },
      handleClickEvent (event) {
          if (event.eventUrl) { window.open(event.eventUrl) }
      }
    },
    props: {
      memberFamilies: {
        type: Array,
        default: () => []
      }
    },
    watch: {
      memberFamilies: {
        deep: true,
        handler () {
          this.loadEventTable()
        }
      }
    }
  }
</script>

<style scoped>
  .chronology-main {
    padding-bottom: 30px;
    word-break: normal;
  }
  .chronology-main .el-table .el-table__header-wrapper {
    overflow: unset !important;
  }
  .text-right {
    text-align: right;
  }
  .title-label{
    background: #321007;
    color: #fff;
    font-size: 1.5em;
    font-weight: bold;
    padding: .5em 0;
    text-align: center;
  }
  .mt2 {
    margin-top: 2em;
  }
  .text-center {
    text-align: center;
  }
  .color-red {
    color: #a5272a;
  }
  .float-right{
     float: right;
     margin-top: -30px;
     margin-right: 5px;
   }
  @media screen and (max-width:768px) {
    .float-right{
      float: unset;
      margin-top: 10px !important;
    }
  }
  .title-message {
      width: 90%;
      font-size: 14px;
      color: red;
      margin-top: -40px;
      margin-left: 30px;
  }
  .table-chronology table {
    border-collapse: unset !important;
  }
  .table-chronology .table td .content {
    text-align: left;
  }
  .table-chronology .table td .content img {
    width: 100%;
    height: 150px;
  }
  .table-chronology .table .btn-delete {
    background-color: #d9534f;
    border-color: #d43f3a;
    border-radius: 5px;
    color: white;
    font-size: 18px;
    cursor: pointer;
  }
  .table-chronology .table .note {
    margin-top: 10px;
    padding-left: 5px;
    margin-bottom: 10px;
  }
  .table-chronology .table tr td a {
    color: #3a8ee6 !important;
  }
  .table-chronology .table {
    width: 100%;
    margin: 1em auto;
    /*border: 2px solid #d6d6d6;*/
    -webkit-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    -moz-box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
    box-shadow: 2px 9px 18px -3px rgba(113,85,85,1);
  }
  .table-chronology .table tr:first-child th:first-child {
    border-top-left-radius: 10px;
  }
  .table-chronology .table tr:first-child th:last-child {
    border-top-right-radius: 10px;
  }
  .table-chronology .table tr:last-child td:first-child {
    border-bottom-left-radius: 10px;
  }
  .table-chronology .table tr:last-child td:last-child {
    border-bottom-right-radius: 10px;
  }
  .table-chronology .table .bg-blue td {
    background: #8edbff;
  }
  .table-chronology .table .bg-lightblue td {
    background: #e6f6fe;
  }
  .table-chronology .table th {
    border-right: 2px solid #d6d6d6;
    border-bottom: 2px solid #d6d6d6;
    border-left: none !important;
    text-align: center;
    background-color: #f7f0df ;
    padding: 1em;
    font-size: 16px;
    font-weight: bold;
    color: #321007;
  }
  .table-chronology.table-responsive {
    border-radius: 10px;
  }
  .table-chronology tr td {
    background-color: #fffdf7;
  }
  .table-chronology .table th {
    vertical-align: middle;
  }
  .table-chronology .table tbody tr:hover>td {
    background-color: #F5F7FA;
  }
  td.td__background--default {
    background: transparent!important;
  }
  .table-chronology td.cell--highlight {
    background-color: #ede1c5;
  }
  .table-chronology .table td:not(.child-table-td) {
    border-bottom: 2px solid #d6d6d6 !important;
    border-right: 2px solid #d6d6d6 !important;
    border-left: none !important;
    text-align: center !important;
    font-size: 14px !important;
    color: #000000;
    padding: 1em;
    /*background: #e6f6fe;*/
    vertical-align: middle;
  }
  .table-chronology .table th {
    text-align: center;
  }
  .table-chronology .table td {
    text-align: center !important;
    font-size: 14px !important;
    color: #000000;
    padding: 1em;
    /*background: #e6f6fe;*/
    vertical-align: middle;
  }
  .table-chronology .table-scroll {
    overflow: hidden !important;
    position:absolute;
    top:0;
    left:0;
    pointer-events:none;
  }
  .table-scroll th, .table-scroll td {
    visibility:hidden !important;
  }
  .table-chronology .table {
    z-index: 4;
    position: relative;
    overflow: auto;
  }
  /*.table-chronology .table .first-column {*/
  /*  left: 0;*/
  /*  position: -webkit-sticky;*/
  /*  position: sticky !important;*/
  /*  visibility:visible !important;*/
  /*  z-index: 5 !important;*/
  /*  border-right: 2px solid #d6d6d6 !important;*/
  /*}*/
  .table-chronology tbody tr:last-child td:first-child {
    vertical-align: top !important;
  }
  .m-auto {
    margin: 0 auto;
    text-align: center !important;
    cursor: default;
  }
  .cursor-pointer {
    cursor: pointer;
  }
  _:-ms-lang(x)::-ms-backdrop,
  .table-chronology .child-table th,
  .table-chronology .child-table td {
      background-color: transparent;
  }
  _:-ms-lang(x)::-ms-backdrop,
  .table-chronology .life-event__member-name,
  .table-chronology .life-event__event-name {
      display: inline-block !important;
  }

  @supports (-webkit-touch-callout: none) {
    /* CSS specific to iOS devices */
    .m-auto:last-child{
      margin-right: 20px !important;
    }
  }
</style>
